@if (contract) {
<form [formGroup]="contractBillingInfoForm">
    <div class="flex-row">
        <span><strong>Billing Profile for {{contract.nurseName}}</strong></span>
    </div>
    @if (contract.isSubcontractor) {
    <div class="flex-row">
        <span>Agency: {{agencyName}}</span>
    </div>
    }
    <div class="flex-row">
        <span>{{contract.profession}} > {{contract.expertise}}</span>
    </div>
    <div class="flex-row">
        <span>{{contract.contractNumshifts1}} - {{contract.contractShiftHours1}} hour
            {{getContractType(contract.contractShiftType1)}}s</span>
    </div>
    <!-- only show second shift row if a contract is not Standard schedule and data exists -->
    @if (isNonStandardShiftWithInfo()) {
    <div class="flex-row">
        <span>{{contract.contractNumshifts2}} - {{contract.contractShiftHours2}} hour
            {{getContractType(contract.contractShiftType2)}}s</span>
    </div>
    }
    <div class="flex-row">
        @if (documentId) {
        <span (click)="downloadDocument()" class="nova__link link-margin">Work Order Confirmation</span>
        }
        <span class="nova__link" (click)="openHistoryModal()">Effective Date History</span>
    </div>
    @if (isEditRates()) {
    <div class="flex-row">
        <div class="flex-col flex-50" #billRatesSection>
            <div class="flex-row">
                <p class="section-title">
                    <strong>Bill Rates</strong>
                    @if (billRatesPastInfo || billRatesFutureInfo) {
                    <span class="effective-date">
                        &nbsp;{{billRatesCurrentInfo}}
                    </span>
                    }
                </p>
            </div>
            @if (billRatesPastInfo || billRatesFutureInfo) {
            <div class="mb-3 effective-note">
                @if (billRatesPastInfo) {
                <div>{{billRatesPastInfo}}</div>
                }
                @if (billRatesFutureInfo) {
                <div>{{billRatesFutureInfo}}</div>
                }
            </div>
            }
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Regular:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (keydown.Tab)="onTabKey()" (change)="calculateDefaultRates(false)"
                            formControlName="billRegRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Overtime:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billOverTimeRate')"
                            formControlName="billOverTimeRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Doubletime:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billDoubleTimeRate')"
                            formControlName="billDoubleTimeRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Charge:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billChargeRate')" formControlName="billChargeRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">On Call:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billOnCallRate')" formControlName="billOnCallRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Call Back:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billCallBackRate')"
                            formControlName="billCallBackRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Holiday:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billHolidayRate')" formControlName="billHolidayRate">
                    </mat-form-field>
                </div>
            </div>
            @if (isLocum && displayLocumPayrollEffectiveDatesHistoryFlag) {
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">24hr Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billOnCall24HourRate')"
                            formControlName="billOnCall24HourRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Night Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billNightCallRate')"
                            formControlName="billNightCallRate">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Weekend Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('billWeekendRate')" formControlName="billWeekendRate">
                    </mat-form-field>
                </div>
            </div>
            }
            <div class="flex-row checkbox-row">
                <span class="flex-col flex-50 checkbox-title">Special Rate:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-checkbox formControlName="specialRate"></mat-checkbox>
                </div>
            </div>
        </div>
        @if (contract.isSubcontractor || !contract.isAyaBrand) {
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Agency Pay</strong>
                    @if (agencyPayPastInfo || agencyPayFutureInfo) {
                    <span class="effective-date">
                        &nbsp;{{agencyPayCurrentInfo}}
                    </span>
                    }
                </p>
            </div>
            @if (agencyPayPastInfo || agencyPayFutureInfo) {
            <div class="mb-3 effective-note">
                @if (agencyPayPastInfo) {
                <div>{{agencyPayPastInfo}}</div>
                }
                @if (agencyPayFutureInfo) {
                <div>{{agencyPayFutureInfo}}</div>
                }
            </div>
            }
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Regular:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input #agencyRegularPay matInput (change)="calculateDefaultRates(true)"
                            formControlName="agencyRegPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Overtime:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyOTPay')" formControlName="agencyOTPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Doubletime:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyDTPay')" formControlName="agencyDTPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Charge:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyChargePay')" formControlName="agencyChargePay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">On Call:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyCallPay')" formControlName="agencyCallPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Call Back:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyCBPay')" formControlName="agencyCBPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Holiday:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyHOLPay')" formControlName="agencyHOLPay">
                    </mat-form-field>
                </div>
            </div>
            @if (isLocum && displayLocumPayrollEffectiveDatesHistoryFlag) {
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">24hr Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyOnCall24HourPay')"
                            formControlName="agencyOnCall24HourPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Night Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyNightCallPay')"
                            formControlName="agencyNightCallPay">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Weekend Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput (focusout)="formatDecimal('agencyWeekendPay')"
                            formControlName="agencyWeekendPay">
                    </mat-form-field>
                </div>
            </div>
            }
        </div>
        }
    </div>
    <div class="flex-row">
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Overtime Rules</strong>
                    @if (overtimeRulesFutureInfo) {
                    <span class="material-icons info-icon" matTooltipClass="tooltip-info tooltip-info__center"
                        [matTooltip]="overtimeRulesFutureInfo" matTooltipPosition="right">
                        info
                    </span>
                    }
                </p>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-40 item-title">in a day</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billOverTimeDayRule">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-40 item-title">in a week</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billOverTimeWeekRule">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-40 item-title">in 2 weeks</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billOverTimeTwoWeekRule">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Doubletime Rules</strong>
                    @if (doubletimeRulesFutureInfo) {
                    <span class="material-icons info-icon" matTooltipClass="tooltip-info tooltip-info__center"
                        [matTooltip]="doubletimeRulesFutureInfo" matTooltipPosition="right">
                        info
                    </span>
                    }
                </p>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-40 item-title">in a day</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billDoubleTimeDayRule">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-40 item-title">in a week</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billDoubleTimeWeekRule">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-40 item-title">in 2 weeks</span>
                <div class="flex-col flex-60 item-container">
                    <mat-form-field appearance="outline">
                        <input matInput type="number" maxlength="100" formControlName="billDoubleTimeTwoWeekRule">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    } @else {
    <div class="flex-row">
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Bill Rates</strong>
                    @if (billRatesPastInfo || billRatesFutureInfo) {
                    <span class="effective-date">
                        &nbsp;{{billRatesCurrentInfo}}
                    </span>
                    }
                </p>
            </div>
            @if (billRatesPastInfo || billRatesFutureInfo) {
            <div class="mb-2 effective-note">
                @if (billRatesPastInfo) {
                <div>{{billRatesPastInfo}}</div>
                }
                @if (billRatesFutureInfo) {
                <div>{{billRatesFutureInfo}}</div>
                }
            </div>
            }
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Regular:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billRegRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Overtime:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOverTimeRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Doubletime:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billDoubleTimeRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Charge:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billChargeRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">On Call:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOnCallRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Call Back:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billCallBackRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Holiday:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billHolidayRate').value || '-'}}
                </div>
            </div>
            @if (isLocum && displayLocumPayrollEffectiveDatesHistoryFlag) {
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">24hr Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOnCall24HourRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Night Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billNightCallRate').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Weekend Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billWeekendRate').value || '-'}}
                </div>
            </div>
            }
            <div class="flex-row checkbox-row">
                <span class="flex-col flex-50 checkbox-title">Special Rate:&nbsp;</span>
                <div class="flex-col flex-50 item-container">
                    {{contractBillingInfoForm.get('specialRate').value ? 'Yes' : 'No'}}
                </div>
            </div>
        </div>
        @if (contract.isSubcontractor || !contract.isAyaBrand) {
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Agency Pay</strong>
                    @if (agencyPayPastInfo || agencyPayFutureInfo) {
                    <span class="effective-date">
                        &nbsp;{{agencyPayCurrentInfo}}
                    </span>
                    }
                </p>
            </div>
            @if (agencyPayPastInfo || agencyPayFutureInfo) {
            <div class="mb-2 effective-note">
                @if (agencyPayPastInfo) {
                <div>{{agencyPayPastInfo}}</div>
                }
                @if (agencyPayFutureInfo) {
                <div>{{agencyPayFutureInfo}}</div>
                }
            </div>
            }
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Regular:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyRegPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Overtime:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyOTPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Doubletime:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyDTPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Charge:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyChargePay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">On Call:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyCallPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Call Back:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyCBPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Holiday:&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyHOLPay').value || '-'}}
                </div>
            </div>
            @if (isLocum && displayLocumPayrollEffectiveDatesHistoryFlag) {
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">24hr Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyOnCall24HourPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Night Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyNightCallPay').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">Weekend Call (Daily):&nbsp;</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('agencyWeekendPay').value || '-'}}
                </div>
            </div>
            }
        </div>
        }
    </div>
    <div class="flex-row">
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Overtime Rules</strong>
                    @if (overtimeRulesFutureInfo) {
                    <span class="material-icons info-icon" matTooltipClass="tooltip-info tooltip-info__center"
                        [matTooltip]="overtimeRulesFutureInfo" matTooltipPosition="right">
                        info
                    </span>
                    }
                </p>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">in a day</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOverTimeDayRule').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">in a week</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOverTimeWeekRule').value || '-'}}
                </div>
            </div>
            <div class="flex-row">
                <span class="flex-col flex-50 item-title">in 2 weeks</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billOverTimeTwoWeekRule').value || '-'}}
                </div>
            </div>
        </div>
        <div class="flex-col flex-50">
            <div class="flex-row">
                <p class="section-title">
                    <strong>Doubletime Rules</strong>
                    @if (doubletimeRulesFutureInfo) {
                    <span class="material-icons info-icon" matTooltipClass="tooltip-info tooltip-info__center"
                        [matTooltip]="doubletimeRulesFutureInfo" matTooltipPosition="right">
                        info
                    </span>
                    }
                </p>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-50 item-title">in a day</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billDoubleTimeDayRule').value || '-'}}
                </div>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-50 item-title">in a week</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billDoubleTimeWeekRule').value || '-'}}
                </div>
            </div>
            <div class="flex-row item-container">
                <span class="flex-col flex-50 item-title">in 2 weeks</span>
                <div class="flex-col flex-50 item-container read-only-item">
                    {{contractBillingInfoForm.get('billDoubleTimeTwoWeekRule').value || '-'}}
                </div>
            </div>
        </div>
    </div>
    }
    <div class="flex-row">
        <div class="flex-100">
            <div class="flex-row">
                <p class="section-title"><strong>Fees/Discount</strong></p>
            </div>
            <div class="flex-row">
                <div class="fees-lbl">
                    <span class="item-title">Contract Fees</span>
                </div>
                <div>
                    <span>{{contract.paybackpct | number:'.2'}}%</span>
                </div>
            </div>
            <div class="flex-row">
                <div class="fees-lbl">
                    <span class="item-title">Ext. Disc.</span>
                </div>
                <div>
                    <span>{{contract.extDiscount}}</span>
                </div>
            </div>
            <div class="flex-row">
                <div class="fees-lbl">
                    <span class="item-title">Early Pymt. Disc.</span>
                </div>
                <div>
                    <span>{{contract.discountPct | number:'.2'}}% / {{contract.discountDays}} Days</span>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-row">
        <p class="section-title"><strong>Orientation</strong></p>
    </div>
    <div class="flex-row justify-space-between">
        <div class="flex-col">
            <div>
                @if (isEditRates()) {
                <div formArrayName="nonBillableOrientationHours">
                    @for (hours of getNonBillableOrientationHours()?.controls; track hours; let i = $index) {
                    <div class="flex-wrap flex-row">
                        <ng-container [formGroup]="getNBOrientationFormGroup(i)">
                            <div class="flex-row flex-align-baseline">
                                <mat-form-field class="number-width" appearance="outline">
                                    <input matInput step="1" type="number" min="0" maxlength="10"
                                        onkeypress="return event.charCode !== 45" formControlName="billableHours"
                                        [attr.data-qa-id]="'hours' + i">
                                </mat-form-field>
                                <div class="mr-2 ml-2"><span>hours &#64;</span></div>
                            </div>
                            <div class="flex-row flex-align-baseline">
                                <mat-form-field class="number-width" appearance="outline">
                                    <input matInput step="1" type="number" min="0" maxlength="10"
                                        onkeypress="return event.charCode !== 45" formControlName="billableRate"
                                        [attr.data-qa-id]="'rates' + i">
                                </mat-form-field>
                                <mat-radio-group formControlName="billableRateType">
                                    <mat-radio-button class="radio-btn ml-2" value="%"
                                        [attr.data-qa-id]="'percent' + i">%</mat-radio-button>
                                    <mat-radio-button class="radio-btn ml-2" value="$"
                                        [attr.data-qa-id]="'dollars' + i">$</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </ng-container>
                    </div>
                    }
                </div>
                }
                @if (!isEditRates()) {
                <div>
                    @for (hours of contractBillingInfoForm.get('nonBillableOrientationHours').value; track hours) {
                    <div class="item-title mb-3">
                        {{ formatOrientationHours(hours.billableHours, hours.billableRate, hours.billableRateType) }}
                    </div>
                    }
                </div>
                }
            </div>
        </div>
        <div class="flex-col">
            <div class="flex-row">
                <span class="item-label">Orientation Taken (1)</span>
                <div class="item-container">
                    <mat-form-field appearance="outline" class="number-width">
                        <input matInput type="number" maxlength="100" formControlName="billOrientation">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row">
                <span class="item-label">Orientation Taken (2)</span>
                <div class="item-container">
                    <mat-form-field appearance="outline" class="number-width">
                        <input matInput type="number" maxlength="100" formControlName="billOrientation2">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    @if (contract.orientation.orientDetails) {
    <div>
        <p class="section-title"><strong>Orientation Details</strong></p>
        <p>{{contract.orientation.orientDetails}}</p>
    </div>
    }
    <div class="flex-row">
        <p class="section-title"><strong>Billing Notes</strong></p>
    </div>
    <div class="flex-row">
        <mat-form-field appearance="outline" class="unconstrained-width flex-95">
            <textarea matInput rows="10" formControlName="notes"></textarea>
        </mat-form-field>
    </div>
    <div class="flex-row">
        <button color="primary" mat-button mat-raised-button (click)="save()" [disabled]="pendingSave">
            SAVE CHANGES
        </button>
    </div>
</form>
}